module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "pa-3",
    attrs: {
      "height": "auto"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": "",
      "text-xs-left": ""
    }
  }, [_c('label', {
    staticClass: "card-title"
  }, [_vm._v("% Ocupación")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "text-xs-right": ""
    }
  }, [_c('v-btn', {
    staticClass: "grey--text",
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.downloadReport
    }
  }, [_c('v-icon', [_vm._v("insert_drive_file")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "grey--text",
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.printReport
    }
  }, [_c('v-icon', [_vm._v("print")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "mb-3": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs7": "",
      "text-xs-left": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, _vm._l((_vm.subsidiaries), function(subsidiary) {
    return _c('v-flex', {
      key: subsidiary.id,
      attrs: {
        "xs4": "",
        "pr-3": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "align-center": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs10": "",
        "pr-0": "",
        "text-xs-left": ""
      }
    }, [_c('span', {
      staticClass: "caption-color",
      style: (("background-color: " + (subsidiary.color)))
    }), _vm._v(" "), _c('label', {
      staticClass: "caption-text"
    }, [_vm._v(_vm._s(subsidiary.name))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs2": "",
        "pl-0": "",
        "text-xs-right": ""
      }
    }, [_c('v-checkbox', {
      staticClass: "caption-checkbox",
      attrs: {
        "disabled": subsidiary.isSelected && _vm.oneSelected
      },
      on: {
        "change": _vm.loadData
      },
      model: {
        value: (subsidiary.isSelected),
        callback: function($$v) {
          subsidiary.isSelected = $$v
        },
        expression: "subsidiary.isSelected"
      }
    })], 1)], 1)], 1)
  }))], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": "",
      "text-xs-right": ""
    }
  }, _vm._l((_vm.filters), function(filter) {
    return _c('v-btn', {
      key: filter.id,
      staticClass: "filter-btn-report",
      class: {
        'active': filter.id === _vm.value
      },
      attrs: {
        "disabled": _vm.loading
      },
      on: {
        "click": function($event) {
          _vm.applyFilter(filter)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(filter.label) + "\n\t\t\t\t\t\t\t\t\t")])
  }))], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('vue-chart', {
    staticClass: "report-container",
    attrs: {
      "type": "horizontalBar",
      "data": _vm.chartData,
      "options": _vm.optionsChart
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "pa-3",
    attrs: {
      "height": "auto"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": "",
      "text-xs-left": ""
    }
  }, [_c('label', {
    staticClass: "card-title"
  }, [_vm._v("% Ocupación")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "text-xs-right": ""
    }
  }, [_c('v-btn', {
    staticClass: "grey--text",
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.downloadReport
    }
  }, [_c('v-icon', [_vm._v("insert_drive_file")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "grey--text",
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.printReport
    }
  }, [_c('v-icon', [_vm._v("print")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "mb-3": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs7": "",
      "text-xs-left": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_vm._l((_vm.subsidiaries), function(subsidiary) {
    return _c('v-flex', {
      key: subsidiary.id,
      attrs: {
        "xs4": "",
        "pr-3": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "align-center": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs10": "",
        "pr-0": "",
        "text-xs-left": ""
      }
    }, [_c('span', {
      staticClass: "caption-color",
      style: (("background-color: " + (subsidiary.color)))
    }), _vm._v(" "), _c('label', {
      staticClass: "caption-text"
    }, [_vm._v(_vm._s(subsidiary.name))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs2": "",
        "pl-0": "",
        "text-xs-right": ""
      }
    }, [_c('v-checkbox', {
      staticClass: "caption-checkbox",
      attrs: {
        "disabled": subsidiary.isSelected && _vm.oneSelected
      },
      on: {
        "change": _vm.loadGraphic
      },
      model: {
        value: (subsidiary.isSelected),
        callback: function($$v) {
          subsidiary.isSelected = $$v
        },
        expression: "subsidiary.isSelected"
      }
    })], 1)], 1)], 1)
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "pr-3": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": "",
      "pr-0": "",
      "text-xs-left": ""
    }
  }, [_c('span', {
    staticClass: "caption-color average"
  }), _vm._v(" "), _c('label', {
    staticClass: "caption-text"
  }, [_vm._v("PROMEDIO")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": "",
      "pl-0": "",
      "text-xs-right": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "caption-checkbox",
    attrs: {
      "true-value": 1,
      "false-value": 0
    },
    on: {
      "change": _vm.loadGraphic
    },
    model: {
      value: (_vm.average),
      callback: function($$v) {
        _vm.average = $$v
      },
      expression: "average"
    }
  })], 1)], 1)], 1)], 2)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('vue-chart', {
    staticClass: "report-container",
    attrs: {
      "type": "bar",
      "data": _vm.barData,
      "options": _vm.optionsChart
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "pa-3",
    attrs: {
      "height": "auto"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-select', {
    staticClass: "filter-select",
    attrs: {
      "item-text": "name",
      "item-value": "id",
      "items": _vm.subsidiaries,
      "hide-details": "",
      "single-line": "",
      "bottom": ""
    },
    on: {
      "input": _vm.loadGraphicLineal
    },
    model: {
      value: (_vm.idSubsidiary),
      callback: function($$v) {
        _vm.idSubsidiary = $$v
      },
      expression: "idSubsidiary"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-menu', {
    staticClass: "menu-date-picker",
    attrs: {
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": ""
    },
    on: {
      "input": _vm.changeIcon
    },
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Fecha de inicio",
      "prepend-icon": "event",
      "append-icon": _vm.arrowIcon,
      "single-line": "",
      "hide-details": "",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.filterDate),
      callback: function($$v) {
        _vm.filterDate = $$v
      },
      expression: "filterDate"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "input": _vm.loadGraphicLineal
    },
    model: {
      value: (_vm.filterDate),
      callback: function($$v) {
        _vm.filterDate = $$v
      },
      expression: "filterDate"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": "",
      "pl-4": "",
      "text-xs-left": ""
    }
  }, [_c('label', {
    staticClass: "card-title"
  }, [_vm._v("Habitaciones ocupadas " + _vm._s(_vm.takenRooms) + "%")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": "",
      "text-xs-left": ""
    }
  }, [_c('label', {
    staticClass: "card-title"
  }, [_vm._v("Ingresos $" + _vm._s(_vm.fee))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": "",
      "text-xs-right": ""
    }
  }, [_c('v-btn', {
    staticClass: "grey--text",
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.downloadReport
    }
  }, [_c('v-icon', [_vm._v("insert_drive_file")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "grey--text",
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.printReport
    }
  }, [_c('v-icon', [_vm._v("print")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "mt-3": ""
    }
  }, [_c('vue-chart', {
    staticClass: "report-container",
    attrs: {
      "type": "line",
      "data": _vm.chartLineData,
      "options": _vm.optionsLineChart
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e8dbbfa8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/clerkinn/reports/Occupancy.vue
// module id = 1697
// module chunks = 17